export const MAIN_URL = 'https://www.naf.no';
export const MEMBERPAGES_URL = 'mitt-naf';
export const DEFAULT_IMG_URL =
  'https://res.cloudinary.com/nafmedier/image/upload/v1694692540/Logo/LogoNAF_480x480_ijk3ga.png';

export const DEFAULT_IMG_PUBLIC_ID = 'v1694692540/Logo/LogoNAF_480x480_ijk3ga.png';

// Navbar links
export const HOME = '/';
export const MEMBERSHIP = '/medlemskap';
export const NAFCENTER = '/bilverksted-og-tester';
export const NAFMC = '/mc';
export const ORDER_ROADSIDE_URL = 'https://naf-veihjelp.sos.eu/order-rsa';
export const NAF_APP_STORE_LINKS = {
  ios: 'https://apps.apple.com/no/app/naf/id1486156324',
  android: 'https://play.google.com/store/apps/details?id=no.naf.medlem',
};

// TODO: Change ERROR_IMG_URL to some NAF Error image
export const MAIN_TITLE = 'NAF - Norges Automobil-Forbund';
export const MAIN_DESCRIPTION =
  'Bli NAF-medlem – 24/7 veihjelp i Europa, advokathjelp, over 60 medlemsfordeler og objektive biltester.';
export const feedbackLabel = 'Kan du utdype hvorfor du gir dette svaret?';

export const VIPPS_BUTTON_SCRIPT_URL = 'https://checkout.vipps.no/checkout-button/v1/vipps-checkout-button.js';

export default {
  MAIN_URL,
  MEMBERPAGES_URL,
  DEFAULT_IMG_URL,
  HOME,
  MEMBERSHIP,
  feedbackLabel,
  VIPPS_BUTTON_SCRIPT_URL,
};

// Used for validation of license plate number.
export const minimumLicensePlateLength = 4;
